import PropTypes from "prop-types"

import HintPill from "./hint_pill"

export default function WarningMessage({ message, variant = "on-dark" }) {
  if (!message) return null

  return (
    <HintPill tone="warning" variant={variant}>
      {message}
    </HintPill>
  )
}

WarningMessage.propTypes = {
  message: PropTypes.string,
  variant: PropTypes.oneOf(["on-dark", "on-light", "on-black"]),
}
